import { render } from "./AuctionsDescriptionsListing.vue?vue&type=template&id=1dfda586&ts=true"
import script from "./AuctionsDescriptionsListing.vue?vue&type=script&lang=ts"
export * from "./AuctionsDescriptionsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__